/*
    Test extensively on updating this file. CSV generation and stored settings in Local Storage depend on this information.
*/
import { identity } from 'ramda';

const insightsColumns = ({ showBroadcastData, showInVenueData }) => {
    let columns = [
        { name: 'Exposures', dbname: 'exposures' },
        { name: 'Duration (sec)', dbname: 'duration' },
        {
            name: 'Impressions',
            dbname: 'impressions',
        },
        { name: 'Video Views', dbname: 'videoViews' },
        { name: 'Engagements', dbname: 'engagements' },
        { name: 'Full Media Value', dbname: 'fullMediaValue' },
        { name: 'MVP', dbname: 'averageMvp' },
        { name: 'Sponsor Media Value', dbname: 'sponsorMediaValue' },
        { name: 'Post Count', dbname: 'postCount' },
        showBroadcastData && {
            name: 'Broadcast Count',
            dbname: 'broadcastCount',
        },
        showInVenueData && {
            name: 'In Venue Event Count',
            dbname: 'inVenueGameCount',
        },
    ].filter(identity);
    return columns;
};

export default insightsColumns;
